// constants
import { MrpShortcuts } from 'components/mrp/mrp.consts';

// types
import type { TFunction } from 'i18next';
import type { ShortcutAction } from 'components/shared/ShortcutProvider';

type GetShortCutsProps = {
  /**
   * Scoped to `mrp.shortcuts.appointmentForm`. Passed in rather than resolved here, so the
   * labels follow a language switch -- a module-level `getFixedT` would freeze them at
   * whichever locale happened to be active when this file was first imported.
   */
  t: TFunction;
  saveAppointment: () => void;
  closeAppointmentForm: () => void;
};

/**
 * The shortcuts the appointment form owns. Registered in the registry rather than handled
 * with a listener of their own, which is what puts them in the `shift+?` overview.
 */
export const getShortCuts = ({
  t,
  saveAppointment,
  closeAppointmentForm
}: GetShortCutsProps): ShortcutAction[] => [
  {
    name: 'saveAppointment',
    label: t('save.label'),
    description: t('save.description'),
    callback: saveAppointment,
    ...MrpShortcuts.SAVE_APPOINTMENT
  },
  {
    name: 'closeAppointmentForm',
    label: t('close.label'),
    description: t('close.description'),
    callback: closeAppointmentForm,
    // The form opens with the cursor in one of its fields, and Escape produces no text, so
    // closing from there has to get past the guard that protects typing.
    allowWhileTyping: true,
    ...MrpShortcuts.CLOSE_APPOINTMENT_FORM
  }
];
